<div class="modal-body">
  <div class="content">
      <div class="content__top">
          <h4 translate>company.dids.verification-data.title</h4>
          <button type="button" class="close" aria-label="Close" (click)="close()">
            <i class="icon-small-close"></i>
          </button>
      </div>
      <div class="content__main">
        <vox-vd-table-readonly [data]="verificationData" [language]="currentLang"></vox-vd-table-readonly>
      </div>
  </div>
</div>
